'use client';

import Icon from '@/components/ui/AppIcon';

interface Topic {
  title: string;
  content: string;
}

interface TopicSectionProps {
  id: string;
  title: string;
  description: string;
  topics: Topic[];
  icon: string;
  reverse?: boolean;
}

export default function TopicSection({ id, title, description, topics, icon, reverse = false }: TopicSectionProps) {
  return (
    <section id={id} className="scroll-mt-24">
      <div className={`flex flex-col lg:flex-row gap-8 lg:gap-16 items-start ${reverse ? 'lg:flex-row-reverse' : ''}`}>
        <div className="w-full lg:w-1/3">
          <div className="sticky top-24">
            <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-xl mb-4">
              <Icon name={icon as any} size={28} className="text-primary" />
            </div>
            <h2 className="text-3xl font-heading font-bold text-text-primary mb-3">
              {title}
            </h2>
            <p className="text-lg text-text-secondary font-body">
              {description}
            </p>
          </div>
        </div>
        
        <div className="w-full lg:w-2/3 space-y-6">
          {topics.map((topic, index) => (
            <div 
              key={index}
              className="bg-card rounded-2xl p-6 md:p-8 shadow-elevation-sm border border-border hover:shadow-elevation-md transition-smooth"
            >
              <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                {topic.title}
              </h3>
              <p className="text-text-secondary leading-relaxed font-body">
                {topic.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
